import React from "react";
import { Oval } from "react-loader-spinner";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { DatePicker } from "../../../../components";
import { getDailyReport, setDailyReportOrdersToShow } from "../../reportsSlice";
import {
  DailyPaymentsCard,
  DailyDeliveriesCard,
  DailyPickupsCard,
  DailyDriversCard,
} from "../../components";

import "./DailyReportView.scss";

export const DailyReportView: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const getDailyReportAPI = useAppSelector(
    (state) => state.reports.getDailyReportAPI
  );
  const dailyReport = useAppSelector((state) => state.reports.dailyReport);

  const [selectedDate, setSelectedDate] = React.useState<Date>(new Date());

  React.useEffect(() => {
    const dateString = moment(selectedDate).format("YYYY-MM-DD");
    dispatch(getDailyReport(dateString));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const onViewOrders = (ids: string[]) => () => {
    dispatch(setDailyReportOrdersToShow(ids));
    navigate("/reports/daily-orders");
  };

  const onViewDriver = (driverId: string) => () => {
    navigate(
      `/reports/daily-driver?driverId=${driverId}&date=${moment(
        selectedDate
      ).format("YYYY-MM-DD")}`
    );
  };

  return (
    <div className="daily-report-view-component">
      <div className="title-container">
        <div className="title-row">
          <div className="title-text">Daily Report</div>

          {getDailyReportAPI.loading && (
            <div style={{ marginLeft: 8 }}>
              <Oval
                color="#131313"
                height={20}
                width={20}
                secondaryColor="#0A60BB"
              />
            </div>
          )}
        </div>

        <DatePicker initialDate={selectedDate} onDateChange={setSelectedDate} />
      </div>

      {dailyReport && (
        <>
          <DailyPaymentsCard
            payments={dailyReport.deliveries.payments}
            onViewOrders={onViewOrders}
          />
          <DailyDeliveriesCard
            deliveriesCount={dailyReport.deliveries.counts}
            onViewOrders={onViewOrders}
          />
          <DailyPickupsCard
            pickupsCount={dailyReport.pickups.counts}
            onViewOrders={onViewOrders}
          />
          <DailyDriversCard
            drivers={dailyReport.drivers}
            onViewDriver={onViewDriver}
          />
        </>
      )}
    </div>
  );
};
